module.exports = __webpack_public_path__ + "static/img/icon-7zip.6509caad.svg";